import React from 'react';
import { EXCHANGE_RETIREMENT_AGREEMENT } from '../../../redux/modules/modals/modals.module';
import Button from '../../Shared/Button/Button';
import { setProgress } from 'src/redux/modules/progress';
import './ExchangingToARetirementAgreement.scss';
import { useDispatch } from 'react-redux';

const ExchangingToARetirementAgreement = ({ fund, closeModal }) => {
  const dispatch = useDispatch();
  return (
    <div>
      <div className="exchange-heading">
        Increase Exchange amount to meet account minimum.
      </div>
      <div className="exchange-body">
        To re-open this investment, you will need to increase your exchange to
        meet this account's minimum{' '}
        {!fund.iClass && (
          <span>
            {fund.displayClassification === 'NON_RETIREMENT'
              ? '($2,500)'
              : '($1,000)'}
          </span>
        )}
        {fund.iClass && (
          <span>
            {fund?.household?.householdBalanceTierStatus.householdAssetTier
              ?.name === 'Personal Services' ||
            fund?.household?.householdBalanceTierStatus.householdAssetTier
              ?.name === 'Enhanced Personal Services'
              ? '($50,000)'
              : '($500,000)'}
          </span>
        )}
      </div>
      <div className="automatic-edit-not-changes-buttons-container">
        <Button
          buttonType="primary"
          id="continue-edit-btn"
          stylename="continue-edit-btn"
          onClick={() => {
            dispatch(setProgress(1));
            closeModal(EXCHANGE_RETIREMENT_AGREEMENT);
          }}
        >
          Change Amount
        </Button>
      </div>
    </div>
  );
};

export default ExchangingToARetirementAgreement;
